class CornerProduits {
  constructor() {
    this._init();
  }

  _init() {
    const handlePaginationScroll = (): void => {
      const isCornerProduitsPage = document.body.classList.contains('page-template-tpl-corner-produits');

      if (!isCornerProduitsPage) {
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);

      // On vérifie les deux types d'URL de pagination de WordPress :
      // 1. Structure standard : /produits/?page=2
      const hasQueryParam = urlParams.has('page');
      // 2. Structure avec permalinks : /produits/page/2/
      const hasPermalinkParam = window.location.pathname.includes('/page/');

      if (!hasQueryParam && !hasPermalinkParam) {
        return; // S'il n'y a pas de pagination dans l'URL, on arrête.
      }

      // --- Action: Scroller vers la section des résultats ---
      const resultsSection: HTMLElement | null = document.getElementById('results');
      const headerElement: HTMLElement | null = document.querySelector('header');

      if (resultsSection && headerElement) {
        const headerHeight: number = headerElement.offsetHeight;
        const resultsPosition: number = resultsSection.getBoundingClientRect().top + window.scrollY;
        const finalScrollPosition: number = resultsPosition - headerHeight;

        window.scrollTo({
          top: finalScrollPosition,
          behavior: 'smooth'
        });
      }
      // Cas de secours : si le header n'est pas trouvé, on utilise la méthode originale.
      else if (resultsSection) {
        resultsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };

    // On exécute notre fonction uniquement lorsque le DOM est entièrement chargé.
    document.addEventListener('DOMContentLoaded', handlePaginationScroll);
  }
}

export const cornerProduits = new CornerProduits();
